import { Link } from "gatsby"
import React from "react"
import { ArticleContentComponentContainer } from "./utils"

export const RelatedTags = ({ tags, heading = "Verwandte Bau-Themen:" }) => {
  return (
    <ArticleContentComponentContainer {...{ custom_classes: "mb-6" }}>
      <p className="title is-4">{heading}</p>
      <div className="buttons">
        {tags?.map(({ slug, short_title }, i) => (
          <Link
            className="button is-rounded is-mitternachtsblau is-outlined is-small"
            key={`tag-link-${i}`}
            to={`/fachzeitschriften/thema/${slug}`}
          >
            {short_title}
          </Link>
        ))}
      </div>
    </ArticleContentComponentContainer>
  )
}
